var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureNearbyFilled = function SvgFeatureNearbyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M12.2 21.6c-.4 0-.8-.1-1.1-.4C8.9 19.3 4 14.5 4 9.8 4 5.5 7.7 2 12.2 2c4.5 0 8.2 3.5 8.2 7.8 0 4.7-5 9.5-7.1 11.3-.3.3-.7.5-1.1.5M9 10.4c0 1.7 1.4 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2 0-1.7-1.5-3.2-3.2-3.2-1.7 0-3.2 1.5-3.2 3.2",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureNearbyFilled;